// Hoisted to module scope: constructing an Intl formatter is expensive and the formats are
// constant, so they are created once instead of per call.
const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
});

const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
});

/** Formats an ISO timestamp for display, for example `Jun 22, 2026, 10:00 AM`. */
export const formatDateTime = (isoTimestamp: string) => dateTimeFormatter.format(new Date(isoTimestamp));

/** Formats the date portion of an ISO timestamp, for example `Jun 22, 2026`. */
export const formatDate = (isoTimestamp: string) => dateFormatter.format(new Date(isoTimestamp));

/** Formats the time portion of an ISO timestamp, for example `10:00 AM`. */
export const formatTime = (isoTimestamp: string) => timeFormatter.format(new Date(isoTimestamp));
